import axios from 'axios';
import { ApiPath } from '../../common/api-path/ApiPath';

export default class SearchDCInputService {

    async getDCs() {
        const response = await axios.get(`${ApiPath.baseUrl}/supply-chain/distribution-center`, { timeout: 12000, timeoutErrorMessage: 'request timeout' });
        return response.data;
    }
}